(function () {
  var path = window.location.pathname.replace(/\/+$/, "");
  if (!path.endsWith("/pages/holiday-sale")) return;

  function getSp(a) {
    var sp = a.getAttribute("data-sm-sp");
    if (sp) return sp;
    var wrap = a.closest("[data-sm-sp]");
    if (wrap) return wrap.getAttribute("data-sm-sp");
    return null;
  }

  function getSale(a) {
    var sale = a.getAttribute("data-sm-sale");
    if (sale) return sale;
    var wrap = a.closest("[data-sm-sale]");
    if (wrap) return wrap.getAttribute("data-sm-sale");
    return "holiday";
  }

  function onClick(e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href*="/products/"]') : null;
    if (!a) return;

    var sp = getSp(a);
    if (!sp) return;

    e.preventDefault();
    e.stopPropagation();

    var sale = (getSale(a) || "holiday").toLowerCase();

    var url = new URL(a.href, window.location.origin);
    url.searchParams.set("sale", sale);
    url.searchParams.set("sp", String(sp));

    try {
      sessionStorage.setItem("sm_sale_context_v2", JSON.stringify({ sale: sale, sp: parseInt(sp, 10) }));
    } catch (e2) {}

    window.location.href = url.toString();
  }

  document.addEventListener("click", onClick, true);
})();
